// extracted by mini-css-extract-plugin
module.exports = {"genericReadMore":"fGsgr","readBtn":"NJBKt","expand":"Kq1kj","text":"LZIiS","atfText":"XE6y1"};